import * as tslib_1 from "tslib";
import { ContextGLTextureFormat } from "../base/ContextGLTextureFormat";
import { GL_ImageBase } from "../image/GL_ImageBase";
/**
 *
 * @class away.pool.GL_ImageBase
 */
var GL_Image2D = (function (_super) {
    tslib_1.__extends(GL_Image2D, _super);
    function GL_Image2D() {
        return _super.apply(this, arguments) || this;
    }
    GL_Image2D.prototype.activate = function (index, mipmap) {
        _super.prototype.activate.call(this, index, mipmap);
        if (mipmap && this._stage.globalDisableMipmap)
            mipmap = false;
        if (!this._mipmap && mipmap) {
            this._mipmap = true;
            this._invalidMipmaps = true;
        }
        if (this._invalidMipmaps) {
            this._invalidMipmaps = false;
            if (mipmap)
                this._texture.generateMipmaps();
        }
    };
    /**
     *
     * @param context
     * @returns {ITexture}
     */
    GL_Image2D.prototype._createTexture = function () {
        this._texture = this._stage.context.createTexture(this._asset.width, this._asset.height, ContextGLTextureFormat.BGRA, true);
    };
    return GL_Image2D;
}(GL_ImageBase));
export { GL_Image2D };



// WEBPACK FOOTER //
// ../dist/lib/image/GL_Image2D.js